/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GrowthGalleryDto } from '../../models/growth-gallery-dto';

export interface GrowthGalleryControllerFindByProductId$Params {
  productId: string;
}

export function growthGalleryControllerFindByProductId(http: HttpClient, rootUrl: string, params: GrowthGalleryControllerFindByProductId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GrowthGalleryDto>>> {
  const rb = new RequestBuilder(rootUrl, growthGalleryControllerFindByProductId.PATH, 'get');
  if (params) {
    rb.path('productId', params.productId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GrowthGalleryDto>>;
    })
  );
}

growthGalleryControllerFindByProductId.PATH = '/api/growth-galleries/product/{productId}';
